angular
  .module('ui-ng-button')
  .factory('phxActionButtonTypeEnum', function (Enumeration, $q, $http, $injector) {
    var STARTS_WITH_PARAM = /^param/i;
    var SPLIT_NUMERAL = /^param-(\d\d?)/i;
    var SPLIT_KEY = /^param-(.*)/i;
    var KEBAB_TO_SNAKE = /-/g;

    var parseNumericParameters = function parseNumericParameters(attrs) {
      return _.map(
        _.sortBy(
          _.filter(attrs, function (value, key) {
            return key.match(STARTS_WITH_PARAM) !== null;
          }),
          function (value, key) {
            var getNumeral = SPLIT_NUMERAL.exec(key);
            return getNumeral === null ? 0 : _.last(getNumeral);
          }
        ),
        function (value, key) {
          return value;
        }
      );
    };

    var parseKeyParameters = function parseKeyParameters(attrs) {
      var parameters = {};
      _.each(
        _.filter(attrs, function (value, key) {
          return key.match(STARTS_WITH_PARAM) !== null;
        }),
        function (value, key) {
          var variable = SPLIT_KEY.exec(key);
          if (variable !== null) {
            this[_.last(variable.replace(KEBAB_TO_SNAKE, '_'))] = value;
          }
        },
        parameters
      );

      return parameters;
    };

    return Enumeration.useDefinitionAsEnum({
      COMMAND: {
        activate: function (scope, element, attrs) {
          var commandFn = $injector.get(attrs.command);
          return commandFn.apply(null, parseNumericParameters(attrs));
        }
      },
      NETWORK: {
        activate: function (scope, element, attrs) {
          var deferred = $q.defer();

          $http({
            method: attrs.method || 'GET',
            url: attrs.url,
            params: parseKeyParameters(attrs)
          })
            .then(function (o) {
              deferred.resolve(o.data);
            })
            .catch(function (o) {
              deferred.reject(o.error);
            });

          return deferred.promise;
        }
      },
      FUNCTION: {
        activate: function (scope, element, attrs) {
          var deferred;
          var promise;
          var rtn = scope.function();

          if (rtn && _.isObject(rtn.promise)) {
            promise = rtn.promise;
          } else if (rtn && _.isObject(rtn.then)) {
            promise = rtn;
          } else {
            deferred = $q.defer();

            if (!_.isUndefined(rtn) && !_.isNull(rtn)) {
              deferred.resolve(rtn);
            } else {
              deferred.reject(rtn);
            }

            promise = deferred.promise;
          }

          return promise;
        }
      }
    });
  })
  .factory('phxActionButtonStatusEnum', function (Enumeration) {
    return Enumeration(['WAITING', 'DEFAULT']);
  })
  .controller(
    'phxActionButtonController',
    function phxActionButtonController($scope, phxActionButtonStatusEnum, phxActionButtonTypeEnum) {
      $scope.enums = {
        actionStatus: phxActionButtonStatusEnum,
        actionType: phxActionButtonTypeEnum
      };

      $scope.flags = {
        isDisabled: false,
        status: phxActionButtonStatusEnum.variableOf(),
        type: phxActionButtonTypeEnum.variableOf()
      };

      $scope.flags.status('DEFAULT');

      $scope.isWaiting = function isWaiting() {
        return phxActionButtonStatusEnum.isEqual($scope.flags.status(), 'WAITING');
      };
    }
  )
  .factory('phxActionButtonDelegateConstant', function () {
    return {
      uniqueComponent: 'ui-ng-button',
      vocabulary: {
        activate: function (scope, element, attrs) {
          var typeDefinition;

          element.addClass('interaction-off phx-action-button--waiting');

          if (scope.isWaiting()) {
            return;
          }

          scope.flags.status('WAITING');

          if (attrs.url) {
            scope.flags.type(scope.enums.actionType.NETWORK);
          } else if (attrs.command) {
            scope.flags.type(scope.enums.actionType.COMMAND);
          } else if (attrs.function) {
            scope.flags.type(scope.enums.actionType.FUNCTION);
          } else {
            throw new EABError('ui-ng-button', 100, {
              attrs: attrs
            });
          }

          typeDefinition = scope.flags.type();
          if (!typeDefinition) {
            return;
          }

          typeDefinition
            .activate(scope, element, attrs)
            .then(function (o) {
              if (scope.onSuccess) {
                scope.onSuccess({ response: o });
              }
            })
            .catch(function (o) {
              if (scope.onFailure) {
                scope.onFailure({ response: o });
              }
            })
            .finally(function (o) {
              if (scope.onFinally) {
                scope.onFinally({ response: o });
              }
              element.removeClass('interaction-off phx-action-button--waiting');
              scope.flags.status('DEFAULT');
              // TODO this still requires a tab
              element[0].focus();
            });
        }
      }
    };
  })
  .directive('phxActionButton', function phxActionButton(DelegateResponder, phxActionButtonDelegateConstant) {
    return {
      restrict: 'E',
      replace: false,
      transclude: true,
      templateUrl: 'ui-ng-button/src/templates/action.html',
      controller: 'phxActionButtonController',
      scope: {
        url: '@',
        method: '@',
        command: '&',
        function: '&',
        onSuccess: '&',
        onFailure: '&',
        onFinally: '&',
        isDisabled: '@'
      },
      compile: function phxActionButtonCompile(element, attrs) {
        element.addClass('phx-action-button');

        return DelegateResponder(phxActionButtonDelegateConstant, function (scope, element, attrs) {
          var buttonElement = angular.element(_.first(element.children()));
          var handleDisabled = function handleDisabled(isDisabled) {
            scope.flags.isDisabled = isDisabled === '' || isDisabled === 'true';

            if (scope.flags.isDisabled) {
              buttonElement.removeAttr('tabindex');
            } else {
              buttonElement.attr('tabindex', '0');
            }
          };

          element.attr('tabindex', '-1');
          attrs.$observe('isDisabled', handleDisabled);
          handleDisabled(attrs.isDisabled);
        });
      }
    };
  })
  .service(
    'phxActionButtonDelegate',
    function phxActionButtonDelegate(DelegateController, phxActionButtonDelegateConstant) {
      DelegateController(this, phxActionButtonDelegateConstant);
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-button/src/core/action.js